import React, { useContext, useCallback } from 'react';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { useLocation } from '@thd-olt-component-react/router';
import PropTypes from 'prop-types';
import {
  shape, string, useDataModel, arrayOf, number, params
} from '@thd-nucleus/data-sources';
import { ResultsSortBy } from '../components/ResultsSortBy';
import { ProductResultsSearchMethodsPLP } from '../utils/product-results-search-methods-PLP';
import { shouldDisplayResultsAppliedOuter, shouldDisplayResultsAppliedInner } from '../utils/searchHelpers';

export const ResultsSortByComposable = ({ renderingConditions = {}, hideFFMFilters }) => {
  const { onSortChangePLP } = ProductResultsSearchMethodsPLP();
  const viewPrimaryFilters = useConfigService('fs-prop:isviewPrimaryFiltersEnabled');
  // TODO: Refactor consumer components to remove the dead code
  // these have been enabled long enough, making the fallback code unreachable
  const isGetItFastOnPlp = true;
  const { customContext } = useContext(ExperienceContext);
  const { variables = {} } = customContext || {};
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;

  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables?.keyword && !variables?.navParam
  };
  const { data = {} } = useDataModel('searchModel', defaultOptions);
  const { metadata } = data?.searchModel || {};
  const { contentType } = metadata || {};
  const isCategory = contentType === 'categorypage';

  const handleSortChange = useCallback((sortParams) => {
    onSortChangePLP({ ...sortParams, path });
  }, [path]);
  if (isCategory) return null;

  const getConditionValue = (conditionName) => {
    switch (conditionName) {
    case 'shouldDisplayResultsAppliedOuter':
      return shouldDisplayResultsAppliedOuter(customContext);
    case 'shouldDisplayResultsAppliedInner':
      return shouldDisplayResultsAppliedInner(customContext);
    case 'viewPrimaryFilters':
      return viewPrimaryFilters;
    case 'isGetItFastOnPlp':
      return isGetItFastOnPlp;
    default:
      return true;
    }
  };

  const hasRenderingConditions = Object.keys(renderingConditions).length > 0;

  if (hasRenderingConditions) {
    const shouldRender = Object.entries(renderingConditions).every(([conditionName, expectedValue]) => {
      const actualValue = getConditionValue(conditionName);
      return actualValue === expectedValue;
    });
    if (!shouldRender) return null;
  }

  return (
    <div className={`sui-p-3 
     ${hideFFMFilters ? 'sui-w-full' : 'sm:sui-w-1/4 sui-w-full sm:sui-inline-block sui-align-bottom'}`}
    >
      <ResultsSortBy
        onSortChange={handleSortChange}
        searchModelData={data}
      />
    </div>
  );
};

ResultsSortByComposable.displayName = 'ResultsSortByComposable';

ResultsSortByComposable.defaultProps = {
  renderingConditions: {},
  hideFFMFilters: false,
};

ResultsSortByComposable.propTypes = {
  renderingConditions: PropTypes.shape({
    shouldDisplayResultsAppliedOuter: PropTypes.bool,
    shouldDisplayResultsAppliedInner: PropTypes.bool,
    viewPrimaryFilters: PropTypes.bool,
    isGetItFastOnPlp: PropTypes.bool,
  }),
  hideFFMFilters: PropTypes.bool,
};

// Define data model with key matching the queried model name 'searchModel'
ResultsSortByComposable.dataModel = {
  searchModel: params({ keyword: string(), navParam: string(), storeId: string() }).shape({
    metadata: shape({
      contentType: string(),
      h1Tag: string()
    }),
    searchReport: shape({
      startIndex: number(),
      pageSize: number(),
      keyword: string(),
      sortBy: string(),
      sortOrder: string()
    }),
    products: arrayOf(shape({
      identifiers: shape({
        productType: string()
      })
    }))
  })
};